export default function Input(theme: any) {
	return {
		MuiTextField: {
			styleOverrides: {
				// Name of the slot
				root: {
					margin: 'normal',
					marginTop: 8,
					marginBottom: 8,
				},
			},
		},
		MuiFormControl: {
			styleOverrides: {
				// Name of the slot
				root: {
					margin: 'normal',
					marginTop: 8,
					marginBottom: 8,
				},
			},
		},
		MuiInputBase: {
			styleOverrides: {
				root: {
					backgroundColor: '#fff',
					'&.Mui-disabled': {
						'& svg': {color: theme.palette.text.disabled},
					},
				},
				input: {
					'&::placeholder': {
						opacity: 1,
						color: theme.palette.text.disabled,
					},
				},
			},
		},
		MuiInput: {
			styleOverrides: {
				underline: {
					'&:before': {
						borderBottomColor: theme.palette.grey[500_56],
					},
				},
			},
		},
		MuiFilledInput: {
			styleOverrides: {
				root: {
					backgroundColor: theme.palette.grey[500_12],
					'&:hover': {
						backgroundColor: theme.palette.grey[500_16],
					},
					'&.Mui-focused': {
						backgroundColor: theme.palette.action.focus,
					},
					'&.Mui-disabled': {
						backgroundColor: theme.palette.action.disabledBackground,
					},
				},
				underline: {
					'&:before': {
						borderBottomColor: theme.palette.grey[500_56],
					},
				},
			},
		},
		MuiOutlinedInput: {
			styleOverrides: {
				root: {
					margin: 'normal',
					marginTop: 8,
					marginBottom: 8,
					'& .MuiOutlinedInput-notchedOutline': {
						borderColor: theme.palette.grey[500_80],
					},
					'&.Mui-disabled': {
						'& .MuiOutlinedInput-notchedOutline': {
							borderColor: theme.palette.action.disabledBackground,
						},
					},
				},
			},
		},
	};
}
